
import { jwtDecode } from "jwt-decode";
export const isTokenExpired = (token) => {
    try {
        const decodedToken = jwtDecode(token);

        // const expireDate = new Date(decodedToken.exp);

        const expireDate = new Date(0);
        expireDate.setUTCSeconds(decodedToken.exp);
        // console.log({ convert: expireDate.getFullYear() });



        const currentDate = new Date();
        // console.log({ expireDate: expireDate.getFullYear(), currentDate: currentDate.getFullYear() })
        // Check if the token is expired
        // console.log({ expireDate: expireDate, currentDate, })


        if (expireDate.getFullYear().toString().length > 4) {
            return true;
        }
        if (expireDate < currentDate) {
            // console.log('Token is expired')
            return true; // Token is expired
        } else {
            // console.log('Token is not expired')
            return false; // Token is not expired
        }

    } catch (error) {
        return true; // Error decoding the token or invalid token format
    }
};
